import { useQuery } from '@apollo/client';
import NotificationsQuery from '@apps/www/src/www/queries/NotificationsQuery';
import NotificationType from '@pkgs/shared/enums/NotificationType';

export const usePendingNotifications = () => {
	const { data } = useQuery(NotificationsQuery, {
		variables: {
			limit: 50,
		},
	});

	const pendingInviteNotifications =
		data?.notifications?.filter((notification) => {
			if (notification.type === NotificationType.INVITE_COLLABORATOR) {
				return notification.relatedBoard?.acceptURL && notification.relatedBoard?.rejectURL;
			}
			if (notification.type === NotificationType.INVITE_TEAM_USER) {
				return notification.relatedTeam?.acceptURL && notification.relatedTeam?.rejectURL;
			}
			return false;
		}) || [];

	const hasPendingNotifications = pendingInviteNotifications.length > 0;

	return {
		notifications: pendingInviteNotifications,
		hasPendingNotifications,
		count: pendingInviteNotifications.length,
	};
};
